//카카오 SDK 온디맨드 로딩
//index.html에서 동기 로딩(렌더 차단)하던 스크립트를 실제 사용하는 시점에만 주입한다.

const scriptCache = {};

function loadScriptOnce(key, attrs){
    if(scriptCache[key]) return scriptCache[key];

    scriptCache[key] = new Promise((resolve, reject) => {
        const script = document.createElement("script");

        Object.keys(attrs).forEach((name) => {
            script[name] = attrs[name];
        });

        script.onload = () => resolve();
        script.onerror = () => {
            delete scriptCache[key];
            reject(new Error(`${key} 스크립트 로딩 실패`));
        };

        document.head.appendChild(script);
    });

    return scriptCache[key];
}

//카카오맵 SDK (window.kakao.maps) - 지도/주소검색 사용 직전 호출
export function loadKakaoMaps(){
    if(window.kakao && window.kakao.maps && window.kakao.maps.services){
        return Promise.resolve();
    }

    return loadScriptOnce("kakaoMaps", {
        src: `//dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.REACT_APP_KAKAO_CLIENT_ID}&libraries=services,clusterer&autoload=false`,
        async: true
    }).then(() => new Promise((resolve) => {
        window.kakao.maps.load(resolve);
    }));
}

//카카오 JS SDK (window.Kakao) - 카카오내비/공유 사용 직전 호출
export function loadKakaoSdk(){
    if(window.Kakao) return Promise.resolve();

    return loadScriptOnce("kakaoSdk", {
        src: "https://t1.kakaocdn.net/kakao_js_sdk/2.7.4/kakao.min.js",
        integrity: "sha384-DKYJZ8NLiK8MN4/C5P2dtSmLQ4KwPaoqAfyA/DfmEc1VDxu4yyC7wy6K1Hs90nka",
        crossOrigin: "anonymous",
        async: true
    });
}
